var diceD = require('./../distances/dice');

module.exports = function dice(a, b) {
    return 1 - diceD(a,b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/dice.js
 ** module id = 107
 ** module chunks = 0
 **/